import type { ConditionGroup, ConditionLeaf, ConditionNode } from './types';

export function conditionNodeId(prefix = ''): string {
  const id = `c-${Math.random().toString(36).slice(2, 9)}`;
  return prefix ? `${prefix}:${id}` : id;
}

export function emptyPredicate(idPrefix = ''): ConditionLeaf {
  return {
    kind: 'predicate',
    id: conditionNodeId(idPrefix),
    left: { kind: 'column', name: '' },
    operator: 'eq',
    right: { kind: 'constant', value: '' },
  };
}

export function emptyGroup(idPrefix = ''): ConditionGroup {
  return {
    kind: 'group',
    id: conditionNodeId(idPrefix),
    combinator: 'AND',
    children: [emptyPredicate(idPrefix)],
  };
}

export function hasMeaningfulCondition(node: ConditionNode | undefined): boolean {
  if (!node) return false;
  if (node.kind === 'predicate') return Boolean(node.left.name.trim());
  return node.children.some((child) => hasMeaningfulCondition(child));
}
